const existing_roles = [
  'create',
  'create:users',
  'delete',
  'delete:users',
  'read',
  'read:users',
  'update:users',
];

export const processClaims = (roles?: string[]) => {
  var actual_roles = [];
  for (const one_role of existing_roles) {
    if (roles?.includes(one_role)) {
      actual_roles.push(one_role);
    }
  }
  return actual_roles;
};

export const USER_ROLE = 'read';
export const ADMIN_ROLE = 'admin';
export const MANAGER_ROLE = 'read:manager';
export const DEVELOPER_ROLE = 'developer';
